import React from "react";
import { connect } from "react-redux";
import { dayWiseBeatDriverJson } from "../../DynamicFormsJson/Transaction/DayWiseBeatDriver";
import {
  getAreaByTalukaPostBody,
  getAreaByUserType,
} from "../../Slice/area.slice";
import { setDayWiseBitAssign } from "../../Slice/dayWiseBitAssign.slice";
import { getDistrictByZone } from "../../Slice/district.slice";
import { getRegionNew } from "../../Slice/region.slice";
import { getStateByRegion } from "../../Slice/state.slice";
import { getTalukaByDistrict } from "../../Slice/taluka.slice";
import {
  getUpdatedDayWiseBeatOutletCountFromAreas,
  getVehicleAssignDayWise,
} from "../../Slice/vehicleAssign.slice";
import { getZoneByState } from "../../Slice/zone.slice";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import {
  dayWiseDriverAssignColumns
} from "../../tableColumns/table-columns";
import { showLoador, showNotification } from "../Landing/Landing.slice";
class DayWiseDriverTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {
        regionDetail: this.props.regionList?.region,
        stateDetail: this.props.stateList?.stateByRegion,
        zoneDetail: this.props.zoneList?.zoneByState,
        districtDetail: this.props.districtList?.districtByZone,
        talukaDetail: this.props.talukaList?.talukaByDistrict,
        areaDetail: this.props.areaList?.areaByTaluka,
        areaByUserDetail: this.props.areaList?.area,
      },
      adminFlag: false,
    };
  }
  async componentDidMount() {
    const {
      getRegionNew,
      setDayWiseBitAssign,
      getAreaByUserType,
      getVehicleAssignDayWise,
      showLoador,
      showNotification,
    } = this.props;
    const userTypeId = localStorage.getItem("userTypeId");

    if (navigator.onLine) {
      setDayWiseBitAssign({ row: [] });

      showLoador({ loador: true });
      getVehicleAssignDayWise().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      if (userTypeId == 1 || userTypeId == 6) {
        showLoador({ loador: true });
        getRegionNew().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            this.setState({
              adminFlag: true,
            });
          }
        });
      } else {
        showLoador({ loador: true });
        getAreaByUserType().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.regionList !== nextProps.regionList) {
      if (this.props.regionList?.region !== nextProps.regionList?.region) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            regionDetail: nextProps.regionList?.region,
          },
        });
      }
    }
    if (this.props.stateList !== nextProps.stateList) {
      if (
        this.props.stateList?.stateByRegion !==
        nextProps.stateList?.stateByRegion
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stateDetail: nextProps.stateList?.stateByRegion,
          },
        });
      }
    }
    if (this.props.zoneList !== nextProps.zoneList) {
      if (
        this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            zoneDetail: nextProps.zoneList?.zoneByState,
          },
        });
      }
    }
    if (this.props.districtList !== nextProps.districtList) {
      if (
        this.props.districtList?.districtByZone !==
        nextProps.districtList?.districtByZone
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            districtDetail: nextProps.districtList?.districtByZone,
          },
        });
      }
    }
    if (this.props.talukaList !== nextProps.talukaList) {
      if (
        this.props.talukaList?.talukaByDistrict !==
        nextProps.talukaList?.talukaByDistrict
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            talukaDetail: nextProps.talukaList?.talukaByDistrict,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (
        this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.areaByTaluka,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (this.props.areaList?.area !== nextProps.areaList?.area) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaByUserDetail: nextProps.areaList?.area,
          },
        });
      }
    }
  }

  onSearchData = async (data) => {
    const {
      getUpdatedDayWiseBeatOutletCountFromAreas,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      let beatByAreasJsonData = {
        areaIds: data.area,
      };

      showLoador({ loador: true });
      await getUpdatedDayWiseBeatOutletCountFromAreas({
        areaIdsData: beatByAreasJsonData,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  getListById = async (data) => {
    const {
      getStateByRegion,
      getZoneByState,
      getDistrictByZone,
      getTalukaByDistrict,
      getAreaByTalukaPostBody,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      if (data.region && data.region != "") {
        showLoador({ loador: true });
        await getStateByRegion({ regionIds: data.region }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.state && data.state != "") {
        showLoador({ loador: true });
        await getZoneByState({ stateIds: data.state }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.zone && data.zone != "") {
        showLoador({ loador: true });
        await getDistrictByZone({ zoneIds: data.zone }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.district && data.district != "") {
        showLoador({ loador: true });
        await getTalukaByDistrict({ districtIds: data.district }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.taluka && data.taluka != "") {
        let talukaIdsByPost = {
          talukaIds: data.taluka,
        };
        showLoador({ loador: true });
        await getAreaByTalukaPostBody({ talukaIds: talukaIdsByPost }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  render() {
    const {
      dayWiseBitAssign,
      setDayWiseBitAssign,
      dayWiseBeatAssignList,
      getVehicleAssignDayWise,
    } = this.props;
    const { dynamicMasterData, adminFlag } = this.state;
    return (
      <>
        <DynamicMainScreen
          showViewButtonInTable={true}
          showDeleteIcon={false}
          dynamicMasterData={dynamicMasterData}
          searchList={
            adminFlag
              ? dayWiseBeatDriverJson.searchList
              : dayWiseBeatDriverJson.searchListForStockHolder
          }
          onSearchData={this.onSearchData}
          getTableData={getVehicleAssignDayWise}
          formPathView={dayWiseBeatDriverJson.formPathView}
          formPath={dayWiseBeatDriverJson.formPath}
          screenTitle={dayWiseBeatDriverJson.screenTitle}
          fieldMeta={dayWiseBeatDriverJson.fieldMeta}
          showPdfDownload={false}
          showExcelDownload={false}
          isActiveURL={dayWiseBeatDriverJson.isActiveURL}
          showAddButton={dayWiseBeatDriverJson.showAddButton}
          tableColumnsToFilter={dayWiseBeatDriverJson.tableColumnsToFilter}
          tableColumns={dayWiseDriverAssignColumns}
          tableData={dayWiseBeatAssignList?.dayWiseBeatAssign}
          apiBaseURL={dayWiseBeatDriverJson.apiBaseURL}
          callApi={false}
          getTableDataById={true}
          showPegination={false}
          getListById={this.getListById}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  dayWiseBitAssign: state.dayWiseBitAssign,
  areaList: state.area,
  regionList: state.region,
  stateList: state.states,
  zoneList: state.zone,
  districtList: state.district,
  talukaList: state.taluka,
  dayWiseBeatAssignList: state.vehicleAssign,
});
const mapDispatchToProps = {
  //   getUpdatedDayWiseBeatFromAreas,
  getRegionNew,
  getZoneByState,
  getDistrictByZone,
  getTalukaByDistrict,
  getAreaByTalukaPostBody,
  getStateByRegion,
  getAreaByUserType,
  showLoador,
  showNotification,
  setDayWiseBitAssign,
  getVehicleAssignDayWise,
  getUpdatedDayWiseBeatOutletCountFromAreas,
};
export default connect(mapStateToProps, mapDispatchToProps)(DayWiseDriverTable);
